import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faGoogle, faMeta } from '@fortawesome/free-brands-svg-icons';
import {
  faArrowProgress,
  faAt,
  faAtlas,
  faBrowser,
  faBullseyePointer,
  faCommentDots,
  faEnvelope,
  faEnvelopeOpenText,
  faMapMarkerAlt,
  faMindShare,
  faRedo,
  faReplyAll,
  faSearch,
  faUsers,
  faWandMagicSparkles,
} from '@fortawesome/pro-regular-svg-icons';

import { CampaignClass, CampaignState } from '@feathr/blackbox';
import { EFontAwesomeKitIcon } from '@feathr/components';

export const campaignColorMap = new Map<CampaignClass, string>([
  [CampaignClass.Segment, 'cyan'],
  [CampaignClass.Lookalike, 'yellow'],
  [CampaignClass.SeedSegment, 'yellow'],
  [CampaignClass.Affinity, 'orange'],
  [CampaignClass.Search, 'orange'],
  [CampaignClass.EmailList, 'red'],
  [CampaignClass.MobileGeoFencing, 'indigo'],
  [CampaignClass.MobileGeoFenceRetargeting, 'indigo'],
  [CampaignClass.Referral, 'teal'],
  [CampaignClass.Conversation, 'blue'],
  [CampaignClass.LandingPage, 'green'],
  [CampaignClass.Facebook, 'cyan'],
  [CampaignClass.EmailListFacebook, 'red'],
  [CampaignClass.TrackedLink, 'red'],
  [CampaignClass.Drip, 'yellow'],
  // TODO: Set correct color for DripStep
  [CampaignClass.DripStep, 'yellow'],
  [CampaignClass.MailrailAutoSend, 'yellow'],
  [CampaignClass.MailrailSingleSend, 'yellow'],
  [CampaignClass.PinpointEmail, 'yellow'],
  [CampaignClass.SmartPinpointEmail, 'yellow'],
  [CampaignClass.AutoPinpointEmail, 'yellow'],
  [CampaignClass.GoogleAdsSmart, 'cyan'],
  [CampaignClass.Omni, 'violet'],
]);

export const campaignStateColorMap = new Map<CampaignState, string>([
  // Color shade 600 is the default. Neutral 600 is too dark, we set it to 500.
  [CampaignState.Draft, 'neutral.5'],
  [CampaignState.Stopped, 'red'],
  [CampaignState.Erroring, 'orange'],
  [CampaignState.Published, 'green'],
  [CampaignState.Publishing, 'yellow'],
]);

export const campaignIconMap = new Map<CampaignClass, IconDefinition>([
  [CampaignClass.Segment, faRedo],
  [CampaignClass.Lookalike, faUsers],
  [CampaignClass.SeedSegment, faUsers],
  [CampaignClass.Affinity, faWandMagicSparkles],
  [CampaignClass.Search, faSearch],
  [CampaignClass.EmailList, faAt],
  [CampaignClass.MobileGeoFencing, faMapMarkerAlt],
  [CampaignClass.MobileGeoFenceRetargeting, faAtlas],
  [CampaignClass.Referral, faEnvelope],
  [CampaignClass.Conversation, faCommentDots],
  [CampaignClass.LandingPage, faBrowser],
  [CampaignClass.GoogleAdsSmart, faGoogle],
  [CampaignClass.Facebook, faMeta],
  [CampaignClass.EmailListFacebook, faMeta],
  [CampaignClass.TrackedLink, faBullseyePointer],
  [CampaignClass.Drip, faArrowProgress],
  // TODO: Set correct icon for DripStep
  [CampaignClass.DripStep, faArrowProgress],
  [CampaignClass.MailrailAutoSend, faReplyAll],
  [CampaignClass.MailrailSingleSend, faEnvelopeOpenText],
  [CampaignClass.PinpointEmail, faEnvelopeOpenText],
  [CampaignClass.SmartPinpointEmail, faMindShare],
  [CampaignClass.AutoPinpointEmail, faReplyAll],
]);

export const customCampaignIconMap = new Map<CampaignClass, EFontAwesomeKitIcon>([
  [CampaignClass.Omni, EFontAwesomeKitIcon.pixlPlus],
]);
